export default __webpack_public_path__ + "static/media/3.0f2a8b02.png";